<script>

import HeaderView from '@/components/HeaderView'
import Toast from '@/components/Toast'
import api from '@/utils/api'

export default {
  name: 'App',
  components: {
    HeaderView,
    Toast
  },
  data () {
    return {
      api
    }
  },
  computed: {
    hasBackground () {
      return !!this.$route.meta.guest
    }
  }
}

</script>

<template lang="pug">

#app.has-background
  header-view
  .content
    transition(appear, enter-active-class="animated fadeIn", leave-active-class="animated fadeOut", mode="out-in")
      router-view
  toast

</template>

<style lang="sass">

@import theme

#app
  position: relative
  background: $white
  min-height: 100%
  &.has-background
    background-color: #f0bd32
    background-size: cover
  &.has-sidenav
    background: $white
    .content
      padding-left: 350px
  .content
    padding: 50px

</style>
